import { useLocale } from '@/shared/composables/useLocale'
import { ar, en } from './locales'
import { createI18n } from 'vue-i18n'

const { locale, fallbackLocale } = useLocale()

const i18nConfig = {
  legacy: false,
  locale,
  fallbackLocale,
  messages: {
    ar, en
  }
}

export const i18n = createI18n(i18nConfig)